import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { extendCommonContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { useBanner } from "../../contexts/banner.js";
import { useStylesheet } from "../../contexts/stylesheet.js";
const LanguageSwitcher = ()=>{
    const { FooterLanguageSwitcherSelect } = useStylesheet().extend(...extendCommonContentStylesheet);
    const { footerDesign: { languageSwitcher: languageSwitcherChoice }, languageSwitcher, onLanguageSwitch } = useBanner();
    const current = useMemo(()=>languageSwitcher.find(({ current })=>current), [
        languageSwitcher
    ]);
    const hasFlag = languageSwitcherChoice === "flags" && !!current?.flag;
    return /*#__PURE__*/ _jsxs(FooterLanguageSwitcherSelect, {
        "data-flag": hasFlag,
        children: [
            hasFlag && /*#__PURE__*/ _jsx("span", {
                style: {
                    backgroundImage: `url(${current.flag})`
                }
            }),
            /*#__PURE__*/ _jsx("select", {
                value: current?.locale,
                "aria-label": current?.name,
                onChange: (e)=>{
                    onLanguageSwitch?.(languageSwitcher.find(({ locale })=>locale === e.target.value));
                },
                children: languageSwitcher.map(({ locale, name })=>/*#__PURE__*/ _jsx("option", {
                        value: locale,
                        children: name
                    }, locale))
            })
        ]
    });
};
export { LanguageSwitcher };
